export const HOME_PAGE_TYPES = {
  DASHBOARD: 'Dashboard',
  PROFIT_AND_LOSS: 'ProfitAndLoss',
  MARKET: 'Market'
} as const;
export type HomePageTypes = (typeof HOME_PAGE_TYPES)[keyof typeof HOME_PAGE_TYPES];
export type HomePageTypesKey = keyof typeof HOME_PAGE_TYPES;
